<template>
    <div id='Hole' :class="hole_bg">
        <img class="hole_con" v-if="item.pass" :src="item.img" alt="">
        <div class="hole_con" v-else>{{ item.def_name }}</div>

    </div>

</template>

<script>
import vue from "vue";
export default vue.component('Hole', {
    props: {
        index: Number,
        item: Object,
    },
    data() {
        return {

        }
    },
    created() {
        // let image = new Image()
        // image.src = "//whhxparty.ehijoy.com/img/whhx_party/friend_invitation_act/game/plot_bg_1.png"
    },
    mounted() {

    },
    methods: {
        start_play() {
            this.$eventBus.$emit('start_play', this.item)
        },
    },
    computed: {
        is_show_title() { return this.item.has_title },
        hole_bg() { return this.item.click_on ? 'que_on' : 'que_def' }


    }

})
</script>

<style scoped>
#Hole {
    position: relative;
    width: 245px;
    height: 227px;
    font-family: 'xique';
}

.que_def {
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/que_def.png') no-repeat center;
    background-size: 100% auto;
}

.que_on {
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/que_on.png') no-repeat center;
    background-size: 100% auto;
}

.hole_con {
    width: 212px;
    height: 200px;
    color: #643b26;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 52px;
    margin: 11px 0 0 22px
}
</style>